import { __assign } from '../../../_virtual/_tslib.js';
import React, { Suspense } from 'react';
import { checkIsArrayEmpty } from '../../../utils/common/dataTypes/array.js';

var PostDocs = React.lazy(function () { return import('./PostDocs.js'); });
var LazyLoadedPostDocs = function (props) {
    var docs = props.docs, showDocs = props.showDocs;
    if (!showDocs || !docs || checkIsArrayEmpty(docs))
        return null;
    return (React.createElement(Suspense, { fallback: null },
        React.createElement(PostDocs, __assign({}, props))));
};

export { LazyLoadedPostDocs };
//# sourceMappingURL=LazyLoadedPostDocs.js.map
